<template>
  <v-layout row wrap>
    <v-flex xs12 md12 v-show="loading">
      <v-progress-linear :indeterminate="true" color="green"></v-progress-linear>
    </v-flex>

    <v-flex xs12 md12 v-show="!loading">
      <v-layout row wrap>
        <v-flex xs12 md12>
          <Breadcrumbs
            :items="$vuetify.breakpoint.smAndDown ? breadcrumbsMobile : breadcrumbs"
          />
        </v-flex>

        <v-flex md3>
          <SideMenuMobile v-if="$vuetify.breakpoint.smAndDown"/>
          <SideMenu v-else />
        </v-flex>

        <v-flex xs12 md8 :class="{'ml-4': $vuetify.breakpoint.smAndUp}">
          <QuestionList 
            :key="this.$route.params.subcategory"
            @setBreadcrumbs="(value) => breadcrumbs = value"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex';
import Breadcrumbs from "@/components/Helpcenter/Breadcrumbs"
import SideMenu from '@/components/Helpcenter/SideMenu.vue'
import QuestionList from '@/components/Helpcenter/QuestionList.vue'
import SideMenuMobile from '@/components/Helpcenter/SideMenuMobile.vue'

export default {
  components: {
    Breadcrumbs,
    SideMenu,
    QuestionList,
    SideMenuMobile
  },
  data() {
    return {
      breadcrumbs: [],
      breadcrumbsMobile: [
        { to: "/", text: "Inicio", disabled: false, exact: true },
        { to: "/centro-de-ayuda", text: "Centro de ayuda", disabled: false, exact: true }
      ],
    }
  },
  computed: {
    ...mapState("helpcenter", ["loading"]),
  }
}
</script>
<style lang="">
  
</style>